import { Grid } from '@mui/material';

import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import ButtonComp from 'common/components/Button/ButtonComp';
import TextFieldWithLabel from 'common/components/TextFieldWithLabel/TextFieldWithLabel';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { RootState } from 'common/store/AppStore';

import { putApplicability } from 'features/HorizonScanning/api';
import {
	ICommentsSection,
	IStatusDetails,
} from 'features/HorizonScanning/api/type-def';
import {
	HORIZON_APPLICABILITY_STATUS,
	HORIZON_PROGRESS_BAR_ELEMENTS,
} from 'features/HorizonScanning/HorizonScanConstants';

import styles from './CommentsSection.module.scss';

const { COMPLETE } = HORIZON_PROGRESS_BAR_ELEMENTS;
const { NOTAPPLICABLE } = HORIZON_APPLICABILITY_STATUS;
const { OK } = HTTP_STATUS_CODES;
const CommentsSection = (props: ICommentsSection) => {
	const { data, makeAPICall } = props;
	const [isDisabled, setIsDisabled] = useState<boolean>(false);

	const [textareaData, setTextareaData] = useState<string>('');

	const currentWorkflowStatus = useSelector(
		(state: RootState) => state.horizonScan.currentWorkflowStatus,
	);

	const onChangeTextareaCommentsData = (event: any) => {
		setTextareaData(event?.target?.value);
	};

	const updateTextareaData = () => {
		makeAPICall(true);
		updatedCommentsData(textareaData);
		setIsDisabled(true);
	};

	useEffect(() => {
		setTextareaData(data?.comments);
		setIsDisabled(false);
	}, [data]);
	const updatedCommentsData = (commentsData: string) => {
		const statusData: IStatusDetails = {
			applicableStatus: NOTAPPLICABLE,
			applicableSecondaryStatus: '',
			comments: commentsData,
		};
		putStatusResponse(statusData, data?.id);
	};

	const putStatusResponse = async (statusData: IStatusDetails, id: string) => {
		if (!statusData?.applicableStatus) return;

		const responseFromApi = await putApplicability(statusData, id);

		if (responseFromApi?.statusCode === OK) {
			makeAPICall(true);
		} else {
			makeAPICall(false);
		}
	};
	return (
		<Grid container xs={12} lg={12} sm={12} md={12} direction="row">
			<Grid
				container
				item
				direction="row"
				xs={12}
				lg={12}
				sm={12}
				md={12}
				mt={2}
			>
				<Grid item xs={12} lg={12} sm={12} md={12}>
					<TextFieldWithLabel
						label="Explaination of non-applicability designation"
						id="non-applicability-description"
						inputProps={{
							'data-testid': 'non-applicability-description',
						}}
						value={textareaData}
						onChange={onChangeTextareaCommentsData}
						required
						error={false}
						helperText=""
						showLabel
						className={styles['task-field-width']}
						positionClass={styles['word-limit-position']}
						wordLimit={420}
						disabled={isDisabled || currentWorkflowStatus === COMPLETE}
					/>
				</Grid>
				{currentWorkflowStatus !== COMPLETE && (
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['comments-btngrp']}
					>
						<ButtonComp
							btnType="primary"
							clickHandler={updateTextareaData}
							disabled={
								isDisabled || !textareaData || textareaData.trim() === ''
							}
							data-testid="addtestmodal-save"
						>
							Save
						</ButtonComp>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};

export default CommentsSection;
